import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../store/configureStore";
import {
  fetchLibraryAdapterAsync,
  librarySelectors,
} from "./myLibrary/MyLibrarySlice";
import { LibraryItems } from "../models/library";
import { fetchCurrentUser } from "./account/accountSlice";
import { BasketContext } from "../context/BasketProvider";
import { BasketHistoryDeatils, getProduct } from "../axios";

const MyLibrary: React.FC = () => {
  const { getBasketHistory, basketDetailsItems, basketHistoryStatus } =
    useContext<any>(BasketContext);
  const [libraryItems, setLibraryItems] = useState<any[]>([]);
  const [status, setStatus] = useState<string>("pending");
  const [libraryLoaded, setLibraryLoaded] = useState<boolean>(true);
  const phoneNumber = localStorage.getItem("phonenumber");

  // Automatically scrolls to top whenever pathname changes
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        setStatus("pending");
        const newData = basketDetailsItems.flatMap(({ data }: any) =>
          data.filter(
            (item: any) =>
              item.productCategoryID !== 1 && item.productCategoryID !== 4
          )
        );
        
        const productData = await Promise.all(
          newData.map((item: any) => getProduct(item.productID))
        );
        

        const finalData = productData.flatMap(({ data }) => data);
        if (finalData.length > 0) {
          setLibraryItems(finalData);
          setStatus("idle");
          setLibraryLoaded(false);
        }
      } catch (error) {
        setStatus("error");
        console.log(error);
      }
    };

    fetchData();
  }, [basketDetailsItems]);

  // console.log("status" , status);

  const navigate = useNavigate();

  useEffect(() => {
    getBasketHistory();
  }, []);``

  const getExtension = (item: LibraryItems) => {
    if (item.type === "ebook") {
      navigate(`/pdf-view/${item.id}`);
    } else {
      navigate(`/video-view/${item.id}`);
    }
  };

  const uniqueMap = new Map<string, LibraryItems>();
  libraryItems.forEach((p) => uniqueMap.set(p.title, p));
  const newValues: LibraryItems[] = Array.from(uniqueMap.values());

  // console.log("new calues" , newValues);
  

  return (
    <>
      {phoneNumber ? (<div className="shop_area shop_reverse mt-60 mb-60 container">
        <div className="row">
          <div className="title-container d-flex flex-column ">
            <h4>کتابخانه من</h4>
            <div className="d-flex mb-1">
              <span className="text-danger">*</span>
              <p>
                {
                  "به فلش کارت‌های خریداری شده از همان قسمت فلش کارت (فروشگاه) دسترسی دارید."
                }
              </p>
            </div>
          </div>
          {libraryItems.length === 0 && libraryLoaded && (
            <div className="loader-6 centerLoader" style={{ width: "90%" }}>
              <span></span>
            </div>
          )}
          {newValues.length > 0 ? (
            <table className="product-table table table-striped table-borderless mt-5">
              
              <tbody>
                {newValues
                  .reverse()
                  .filter((I) => I.categoryID !== 1)
                  .filter((I) => I.type !== "fiziki" && I.type !== "aks")
                  .map((item, index) => (
                    <tr key={index}>
                      <td className="border-right">{item.title}</td>
                      <td>
                        <button
                          className="library_see_moreBtn"
                          style={{ marginTop: 0 }}
                          onClick={() =>
                            item.categoryID === 4
                              ? navigate("/shop?id=4")
                              : getExtension(item)
                          }
                        >
                          مشاهده
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          ) : status === "idle" ? (
            <span>موردی برای نمایش وجود ندارد یا وارد حساب کاربری نشده‌اید.</span>
          ) : status === "error" ? (
            <span>در نمایش دیتا مشکل پیش آمده مجدد تلاش کنید</span>
          ) : (
            <></>
          )}
        </div>
      </div>) : <Navigate to="/login" />}
    </>
  ); 
};

export default MyLibrary;
